var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithAuth from './baseQueryWithAuth';
export var queryBuilderFiltersApi = createApi({
    reducerPath: 'queryBuilderFiltersApi',
    baseQuery: baseQueryWithAuth,
    keepUnusedDataFor: 60 * 60,
    endpoints: function (builder) { return ({
        getFilters: builder.query({
            query: function (args) { return ({
                url: args.url + '?staging=wip',
                method: 'POST',
                body: args,
            }); },
        }),
        getDynamicFilters: builder.query({
            query: function (args) { return ({
                url: args.url + '?staging=wip',
                method: 'POST',
                body: __assign(__assign({}, args), { endDate: Date.now() })
            }); },
        }),
        getQueryBuilder: builder.query({
            query: function (args) { return ({
                url: args.url,
                method: 'POST',
                body: args,
            }); },
        }),
        getQueryTranslation: builder.query({
            query: function (args) { return ({
                url: args.url,
                method: 'POST',
                body: args,
            }); },
        })
    }); },
});
export var useGetFiltersQuery = queryBuilderFiltersApi.useGetFiltersQuery, useGetDynamicFiltersQuery = queryBuilderFiltersApi.useGetDynamicFiltersQuery, useLazyGetDynamicFiltersQuery = queryBuilderFiltersApi.useLazyGetDynamicFiltersQuery, useGetQueryBuilderQuery = queryBuilderFiltersApi.useGetQueryBuilderQuery, useLazyGetQueryBuilderQuery = queryBuilderFiltersApi.useLazyGetQueryBuilderQuery, useLazyGetQueryTranslationQuery = queryBuilderFiltersApi.useLazyGetQueryTranslationQuery;
export var api = queryBuilderFiltersApi;
